import { mutationTree } from "typed-vuex";
import state, { TabState } from "./state";
import { NavigationTab } from "~/types/types";

/**
 * Tab module mutations.
 */
const mutations = mutationTree(state, {
    /**
     * Sets the active tab.
     *
     * @param {TabState} state
     * @param {NavigationTab} tab
     */
    setTab(state: TabState, tab: NavigationTab): void {
        state.active = tab;
    },

    /**
     * Clears the user module state.
     *
     * @param {UserState} state
     */
    clear(current: TabState): void {
        current.active = state().active;
    },
});

export default mutations;
